var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArrow3Left(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#3c3f45;}.a{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 11)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 56,
    height: 56,
    transform: "translate(-11 -11)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.895 -1.895)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(6.895 6.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M953.849-4793.577a26.419,26.419,0,0,1-6.447-1.793c-1.664-.781-2.508-1.7-2.508-2.719,0-1.491,1.793-2.777,5.184-3.722a45.329,45.329,0,0,1,11.434-1.36l-4.079-4.08a.5.5,0,0,1,0-.707.5.5,0,0,1,.354-.147.5.5,0,0,1,.354.147l4.758,4.758a.5.5,0,0,1,0,.707l-4.758,4.758a.5.5,0,0,1-.707,0,.5.5,0,0,1,0-.708l3.726-3.726a43.8,43.8,0,0,0-10.813,1.32,12.557,12.557,0,0,0-3.384,1.392c-.487.321-1.068.818-1.068,1.367,0,1.023,2.136,2.487,8.128,3.527a48.758,48.758,0,0,0,7.819.556.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5A50.684,50.684,0,0,1,953.849-4793.577Z",
    transform: "translate(-935.364 4818.563)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow3Left);
export default __webpack_public_path__ + "static/media/icon-arrow3-left.d75c8eda.svg";
export { ForwardRef as ReactComponent };